import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Route } from '@angular/router';
import { Store } from '@ngrx/store';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Observable, timer } from 'rxjs/index';
import { map, shareReplay } from 'rxjs/operators';
import { APP_ROUTES } from '../app-routing.module';
import { AuthenticationActions } from '../auth/state/authentication.actions';
import { AuthenticationSelectors } from '../auth/state/authentication.selectors';
import { User } from './model/user.model';
import { AccountService } from './services/account.service';
import { TopNavigationBarActions } from './state/top-navigation-bar.actions';

@Component({
    selector: 'top-navigation-bar',
    templateUrl: './top-navigation-bar.component.html',
    providers: [Location]
})
export class TopNavigationBarComponent {

    // TODO: Consider if this should be loaded by AppModule or elsewhere to allow making e.g. appointment request page without loading it

    clock$: Observable<Date> = timer(0, 1000)
        .pipe(
            map(tick => new Date()),
            shareReplay(1)
        );

    private permittedRoutes$: Observable<Array<Route>>;
    public routesTop$: Observable<Array<Route>>;
    public routesProfile$: Observable<Array<Route>>;
    public isCollapsed = true;

    public currentUser$: Observable<User>;
    isAdmin$: Observable<boolean>;
    portalVersion$: Observable<string>;
    viewSessionId$: Observable<string>;
    isAuthenticatedFromAdmin$: Observable<boolean>;
    isInIframe: boolean;

    constructor(
        private accountService: AccountService,
        private authenticationSelectors: AuthenticationSelectors,
        private store: Store<any>) {
        this.isInIframe = window.self !== window.top;

        // Get link'able part of path from each route to use for routerLink
        for (const route of APP_ROUTES) {
            if (route.data) {
                route.data.routerLink = route.path.includes(':')
                    ? route.path.substring(0, route.path.indexOf(':') - 1)
                    : route.data.routerLink = route.path;
            }
        }

        this.currentUser$ = this.authenticationSelectors.selectCurrentUser();
        this.isAdmin$ = this.authenticationSelectors.selectIsAdmin();
        this.portalVersion$ = this.authenticationSelectors.selectPortalVersion();
        this.viewSessionId$ = this.authenticationSelectors.selectViewSessionId();
        this.isAuthenticatedFromAdmin$ = this.authenticationSelectors.selectIsAuthenticatedFromAdmin();

        this.permittedRoutes$ = this.currentUser$
            .pipe(
                map(user =>
                    APP_ROUTES.filter(route =>
                        this.accountService.hasUserPermission(route, user)))
            );

        this.routesTop$ = this.permittedRoutes$
            .pipe(
                map(routes =>
                    routes.filter(route =>
                        route.data !== undefined &&
                        route.data.parent !== undefined &&
                        route.data.parent === 'top')
                )
            );

        this.routesProfile$ = this.permittedRoutes$
            .pipe(
                map(routes =>
                    routes.filter(route =>
                        route.data !== undefined &&
                        route.data.parent !== undefined &&
                        route.data.parent === 'profile')
                )
            );
    }

    logout(): void {
        this.store.dispatch(AuthenticationActions.logoutUser());
    }

    displayAdaptiveRulesDialog(): void {
        this.store.dispatch(TopNavigationBarActions.openAdaptiveRule());
    }
}
